export const translations = {
  en: {
    // Common
    loading: 'Loading...',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    create: 'Create',
    update: 'Update',
    search: 'Search',
    filter: 'Filter',
    appName: 'Lead Management System',
    appNameShort: 'Leads',

    // Navigation
    dashboard: 'Dashboard',
    leads: 'Leads',
    calendar: 'Calendar',
    settings: 'Settings',
    apiDocs: 'API Documentation',
    logout: 'Logout',

    // Auth
    email: 'Email',
    password: 'Password',
    signIn: 'Sign In',
    loginSuccess: 'Login successful!',
    loginFailed: 'Login failed',
    emailRequired: 'Email is required',
    emailInvalid: 'Email is invalid',
    passwordRequired: 'Password is required',
    passwordMin: 'Password must be at least 6 characters',
    signInToAccount: 'Sign in to your account',
    defaultCredentials: 'Default credentials:',
    enterEmail: 'Enter your email',
    enterPassword: 'Enter your password',
    unexpectedError: 'An unexpected error occurred',
    loggedOutSuccess: 'Logged out successfully',
    switchLanguage: 'Switch Language',
    toggleSidebar: 'Toggle sidebar',

    // Dashboard
    leadPipeline: 'Lead Pipeline',
    dragToUpdate: 'Drag and drop leads to update their status',
    addLead: 'Add Lead',

    // Leads
    allLeads: 'All Leads',
    unnamedLead: 'Unnamed Lead',
    company: 'Company',
    phone: 'Phone',
    noLeads: 'No leads',
    viewDetails: 'View details',
    deleteLead: 'Delete lead',
    noDate: 'No date',

    // Statuses
    leadStatuses: 'Lead Statuses',
    manageStatuses: 'Manage the status columns displayed in your Kanban board',
    addStatus: 'Add Status',
    editStatus: 'Edit Status',
    createStatus: 'Create Status',
    updateStatus: 'Update Status',
    statusName: 'Status Name',
    color: 'Color',
    displayOrder: 'Display Order',
    active: 'Active',
    inactive: 'Inactive',
    actions: 'Actions',
    order: 'Order',
    statusCreated: 'Status created successfully',
    statusUpdated: 'Status updated successfully',
    statusDeleted: 'Status deleted successfully',
    statusDeleteFailed: 'Failed to delete status. It may be in use by leads.',
    deleteStatusConfirm: 'Are you sure you want to delete this status? This action cannot be undone.',
    failedToLoadStatuses: 'Failed to load statuses',
    failedToSaveStatus: 'Failed to save status',

    // Field Labels
    fullNameLabel: 'Full Name',
    emailLabel: 'Email',
    phoneLabel: 'Phone',
    companyLabel: 'Company',
    messageLabel: 'Message',
    adName: 'Ad Name',
    campaignName: 'Campaign Name',
    adsetName: 'Ad Set Name',
    formId: 'Form ID',
    adId: 'Ad ID',
    campaignId: 'Campaign ID',
    fbLeadId: 'Facebook Lead ID',
    createdTime: 'Created Time',
    createdDate: 'Created Date',
    assignedToLabel: 'Assigned To',
    sourceLabel: 'Source',

    // Settings
    settingsTitle: 'Settings',
    statuses: 'Statuses',
    customFields: 'Custom Fields',
    users: 'Users',
    comingSoon: 'Coming soon...',
    displaySettings: 'Display Settings',
    branding: 'Branding',
    brandingSettings: 'Branding Settings',
    brandingDescription: 'Customize your application logo and favicon',
    applicationLogo: 'Application Logo',
    uploadLogo: 'Upload Logo',
    logoRequirements: 'Recommended: PNG or SVG, max 2MB, square format (e.g., 512x512px)',
    noLogo: 'No logo uploaded',
    applicationTitle: 'Application Title',
    customTitle: 'Custom Title',
    titleRequirements: 'Enter a custom title to display alongside your logo in the navigation bar',
    titlePlaceholder: 'e.g., Lead Management System',
    titleUpdated: 'Title updated successfully',
    titleRemoved: 'Title removed successfully',
    favicon: 'Favicon',
    uploadFavicon: 'Upload Favicon',
    faviconRequirements: 'Recommended: ICO or PNG, max 512KB, 32x32px or 16x16px',
    fileTooLarge: 'File size must be less than 2MB',
    faviconTooLarge: 'Favicon size must be less than 512KB',
    logoUpdated: 'Logo updated successfully',
    faviconUpdated: 'Favicon updated successfully',
    logoRemoved: 'Logo removed successfully',
    faviconRemoved: 'Favicon removed successfully',
    note: 'Note',
    brandingNote: 'Your branding will be saved in browser storage and applied across the application. Clear browser data will reset these settings.',
    remove: 'Remove',
    kanbanCardFields: 'Kanban Card Fields',
    selectCardFields: 'Select which fields to display on Kanban cards',
    saveCardSettings: 'Save Card Settings',
    modalViewFields: 'Modal View Fields',
    selectModalFields: 'Select which fields to display in the lead detail modal',
    saveModalSettings: 'Save Modal Settings',
    activityTags: 'Activity Tags',
    manageTags: 'Manage tags that can be added to activities',
    saveTags: 'Save Tags',
    addNewTag: 'Add new tag...',
    addTag: 'Add Tag',
    resetToDefaults: 'Reset to Defaults',
    required: 'required',
    cardDisplaySettingsSaved: 'Card display settings saved',
    modalDisplaySettingsSaved: 'Modal display settings saved',
    activityTagsSaved: 'Activity tags saved',
    tagAlreadyExists: 'Tag already exists',
    resetToDefaultSettings: 'Reset to default settings',

    // Quick Stats
    quickStats: 'Quick Stats',
    totalLeads: 'Total Leads',
    won: 'Won',

    // API Documentation
    apiDocumentation: 'API Documentation',
    apiDocDescription: 'Complete reference for all available API endpoints',
    baseUrl: 'Base URL',
    authentication: 'Authentication',
    authDescription: 'Include JWT token in Authorization header as',
    howToAuthenticate: 'How to Authenticate',
    authStep1: 'Login using',
    authStep1b: 'with your email and password',
    authStep2: 'Save the token from the response',
    authStep3: 'Include the token in all subsequent requests in the Authorization header',
    exampleCurl: 'Example with cURL',
    exampleJavaScript: 'Example with JavaScript (fetch)',
    requiresAuth: 'Auth Required',
    queryParameters: 'Query Parameters',
    requestBody: 'Request Body',
    response: 'Response',
    copy: 'Copy',
    exampleUsage: 'Example Usage',

    // Toasts
    failedToLoad: 'Failed to load data',
    leadStatusUpdated: 'Lead status updated',
    failedToUpdate: 'Failed to update lead status',

    // Lead Form
    fullName: 'Full Name',
    fullNameRequired: 'Full name is required',
    emailRequired: 'Email is required',
    message: 'Message',
    status: 'Status',
    statusRequired: 'Status is required',
    selectStatus: 'Select status...',
    createLead: 'Create Lead',
    updateLead: 'Update Lead',
    leadCreated: 'Lead created successfully',
    leadUpdated: 'Lead updated successfully',
    failedToCreateLead: 'Failed to create lead',
    failedToUpdateLead: 'Failed to update lead',
    additionalNotes: 'Additional notes or message...',
    actionDate: 'Action Date',
    actionDateHelp: 'Trial session date, follow-up date, or next contact date',
    assignToEvent: 'Assign to Event',
    noEvent: 'No Event',
    assignToEventHelp: 'Assigning to an event will automatically set the action date',
    actionDateFromEvent: 'Action date is set from the event',
    preferredDays: 'Preferred Days',
    preferredDaysHelp: 'Select the days that work best for the lead',
    sunday: 'Sunday',
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    messageTypes: 'Message Types',
    messageTypesHelp: 'Select how the lead prefers to be contacted',
    messageType: 'Message Type',
    manageMessageTypes: 'Define the types of messages that leads can receive',
    addNewMessageType: 'Add new message type...',
    add: 'Add',
    noMessageTypes: 'No message types defined yet',
    messageTypeRequired: 'Message type name is required',
    messageTypeAdded: 'Message type added successfully',
    messageTypeUpdated: 'Message type updated successfully',
    messageTypeDeleted: 'Message type deleted successfully',
    deleteMessageTypeConfirm: 'Are you sure you want to delete this message type?',

    // Events
    events: 'Events',
    event: 'Event',
    manageEvents: 'Manage trial sessions, workshops, and other events',
    viewEventsCalendar: 'View all events in calendar format',
    today: 'Today',
    month: 'Month',
    week: 'Week',
    day: 'Day',
    upcomingEvents: 'Upcoming',
    pastEvents: 'Past',
    privateEvents: 'Private',
    fullEvents: 'Full',
    recurrence: 'Recurrence',
    recurrenceType: 'Repeat',
    noRecurrence: 'Does not repeat',
    recurrenceEndDate: 'Ends on',
    recurrenceEndDateHelp: 'Last date for recurring events',
    addEvent: 'Add Event',
    editEvent: 'Edit Event',
    eventName: 'Event Name',
    eventDate: 'Event Date',
    activityCategory: 'Activity Category',
    selectActivity: 'Select Activity...',
    location: 'Location',
    capacity: 'Capacity',
    visibility: 'Visibility',
    public: 'Public',
    private: 'Private',
    assigned: 'Assigned',
    noEvents: 'No events found',
    privateEvent: 'Private Event',
    past: 'Past',
    full: 'Full',
    unlimited: 'Unlimited',
    upcomingOnly: 'Upcoming Only',
    showAll: 'Show All',
    eventCreated: 'Event created successfully',
    eventUpdated: 'Event updated successfully',
    eventDeleted: 'Event deleted successfully',
    deleteEventConfirm: 'Are you sure you want to delete this event?',
    cannotDeleteEventWithLeads: 'Cannot delete event with assigned leads',
    eventDeleteFailed: 'Failed to delete event',
    failedToLoadEvents: 'Failed to load events',
    failedToSaveEvent: 'Failed to save event',
    capacityHelp: '0 = unlimited capacity',
    description: 'Description',
    assignedLeads: 'Assigned Leads',
    noLeadsAssigned: 'No leads assigned to this event',
    addLeadToEvent: 'Add Lead to Event',
    addLeadToEventInfo: 'Select a lead to add to this event.',
    searchLead: 'Search Lead',
    selectLead: 'Select Lead',
    searchByNameOrPhone: 'Search by name or phone...',
    pleaseSelectLead: 'Please select a lead',
    leadAddedToEvent: 'Lead added to event successfully',
    failedToAddLead: 'Failed to add lead to event',
    add: 'Add',
    viewAssignedLeads: 'View Assigned Leads',
    failedToLoadLeads: 'Failed to load leads',
    name: 'Name',

    // Lead Detail Modal
    addNewLead: 'Add New Lead',
    leadDetails: 'Lead Details',
    editLead: 'Edit Lead',
    eventHistory: 'Event History',
    noEventHistory: 'No event attendance records',
    upcoming: 'Upcoming',
    markedBy: 'Marked by',
    close: 'Close',
    created: 'Created',
    assignedTo: 'Assigned To',
    source: 'Source',
    activityTimeline: 'Activity Timeline',
    noActivity: 'No activity yet',

    // Activity Types
    statusChange: 'changed status from',
    to: 'to',
    leadCreatedActivity: 'created the lead',
    leadUpdatedActivity: 'updated lead information',
    noteAdded: 'added a note',
    assignmentChanged: 'assigned lead to',
    system: 'System',
    justNow: 'Just now',
    minuteAgo: 'minute ago',
    minutesAgo: 'minutes ago',
    hourAgo: 'hour ago',
    hoursAgo: 'hours ago',
    dayAgo: 'day ago',
    daysAgo: 'days ago',

    // Errors
    failedToLoadLeadDetails: 'Failed to load lead details',
    failedToLoadStatuses: 'Failed to load statuses',
    failedToLoadActivityTimeline: 'Failed to load activity timeline',

    // Delete
    confirmDelete: 'Confirm Delete',
    confirmDeleteMessage: 'Are you sure you want to delete',
    deleteWarning: 'This action cannot be undone.',
    leadDeleted: 'Lead deleted successfully',
    failedToDelete: 'Failed to delete lead',

    // Duplicates
    checkingDuplicates: 'Checking for duplicates...',
    duplicateLeadsFound: 'Possible duplicate leads found',
    duplicate: 'Duplicate',
    duplicateWarning: 'This lead has duplicate phone numbers with other leads',

    // Bulk Actions
    selectAll: 'Select All',
    deselectAll: 'Deselect All',
    selectAllInStatus: 'Select all in this status',
    deselectAllInStatus: 'Deselect all in this status',
    bulkActions: 'Bulk Actions',
    selectedLeads: 'leads selected',
    bulkDelete: 'Delete Selected',
    bulkDeleteConfirm: 'Are you sure you want to delete the selected leads?',
    bulkDeleteSuccess: 'Successfully deleted leads',
    bulkDeleteFailed: 'Failed to delete some leads',
    bulkEdit: 'Bulk Edit',
    bulkEditInfo: 'Changes will be applied to',
    bulkEditNote: 'Only selected fields will be updated. Empty fields will remain unchanged.',
    bulkUpdateSuccess: 'Successfully updated',
    bulkUpdateFailed: 'Failed to update leads',
    bulkUpdatePartialFail: 'Failed to update',
    noChange: '-- No Change --',
    noChangesSelected: 'Please select at least one field to update',
    updateSelected: 'Update Selected',
    noLeadsSelected: 'No leads selected',
    selectionMode: 'Selection Mode',
    exitSelectionMode: 'Exit Selection',

    // Users
    userManagement: 'User Management',
    manageSystemUsers: 'Manage system users and their permissions',
    addUser: 'Add User',
    editUser: 'Edit User',
    createUser: 'Create User',
    updateUser: 'Update User',
    role: 'Role',
    admin: 'Admin',
    user: 'User',
    passwordLabel: 'Password',
    passwordLabelOptional: 'Password (leave blank to keep current)',
    userUpdatedSuccessfully: 'User updated successfully',
    userCreatedSuccessfully: 'User created successfully',
    userDeletedSuccessfully: 'User deleted successfully',
    confirmDeleteUser: 'Are you sure you want to delete this user?',
    failedToLoadUsers: 'Failed to load users',

    // Views
    views: 'Views',
    filteredViews: 'Filtered Views',
    filteredViewsDescription: 'Create views filtered by activity type (campaign name)',
    addView: 'Add View',
    editView: 'Edit View',
    createView: 'Create View',
    updateView: 'Update View',
    viewName: 'View Name',
    activityFilter: 'Activity Filter',
    filterByActivity: 'Filter by Activity',
    filterByActivityHelp: 'This will filter leads where the campaign name contains the selected activity',
    allActivities: 'All Activities',
    default: 'Default',
    setAsDefault: 'Set as default',
    noViewsYet: 'No Views Yet',
    createFirstViewDescription: 'Create your first filtered view to organize leads by activity',
    createFirstView: 'Create First View',
    viewUpdatedSuccessfully: 'View updated successfully',
    viewCreatedSuccessfully: 'View created successfully',
    viewDeletedSuccessfully: 'View deleted successfully',
    confirmDeleteView: 'Are you sure you want to delete this view?',
    defaultViewUpdated: 'Default view updated',
    failedToSetDefaultView: 'Failed to set default view',
    failedToLoadViews: 'Failed to load views',
    failedToLoadActivities: 'Failed to load activities',
    all: 'All',

    attendance: 'Attendance',
    attended: 'Attended',
    absent: 'Absent',
    pending: 'Pending',
    resetAttendance: 'Reset attendance',
    attendanceUpdated: 'Attendance updated successfully',
    failedToUpdateAttendance: 'Failed to update attendance',
    healthDeclaration: 'Health Declaration',
    healthDeclarationReceived: 'Health declaration received - Click to cancel',
    healthDeclarationNotReceived: 'No health declaration - Click to mark',
    healthDeclarationUpdated: 'Health declaration updated successfully',
    missingHealthDeclaration: 'Missing health declaration',
    failedToUpdateHealthDeclaration: 'Failed to update health declaration',
    assignedOfCapacity: 'Assigned / Capacity',
    didntArrive: "Didn't Arrive",
    unassign: 'Unassign',
    confirmUnassignLead: 'Are you sure you want to unassign this lead from the event?',
    leadUnassigned: 'Lead unassigned from event successfully',
    failedToUnassignLead: 'Failed to unassign lead from event',
    cannotUnassignAttendedLead: 'Cannot unassign lead who attended the event. Mark as absent first.',
    pleaseSelectGroup: 'Please select a group',
    groupAssignedToEvent: 'Group assigned to event successfully',
    eventCapacityExceeded: 'Event capacity would be exceeded',
    groupNotFound: 'Group not found',
    eventNotFound: 'Event not found',
    failedToAssignGroup: 'Failed to assign group to event',
    members: 'Members',
    totalMembers: 'Total Members',
    addMember: 'Add Member',
    addMembers: 'Add Members',
    noMembers: 'No members in this group',
    remove: 'Remove',
    confirmRemoveMember: 'Are you sure you want to remove this member from the group?',
    memberRemoved: 'Member removed from group successfully',
    failedToRemoveMember: 'Failed to remove member from group',
    searchLeads: 'Search Leads',
    searchByNamePhoneEmail: 'Search by name, phone, or email...',
    noLeadsFound: 'No leads found matching your search',
    noAvailableLeads: 'No available leads without a group',
    failedToAddMember: 'Failed to add member to group',
    memberAdded: 'Member added to group successfully',
    groupMembers: 'Group Members',
    viewMembers: 'View Members',
    failedToLoadMembers: 'Failed to load group members',
    failedToLoadGroups: 'Failed to load groups',
    groupUpdated: 'Group updated successfully',
    groupCreated: 'Group created successfully',
    groupDeleted: 'Group deleted successfully',
    deleteGroupConfirm: 'Are you sure you want to delete this group?',
    cannotDeleteGroupWithMembers: 'Cannot delete group with members. Remove all members first.',
    groupDeleteFailed: 'Failed to delete group',
    failedToSaveGroup: 'Failed to save group',
    groupAlreadyExists: 'A group with this name already exists',
    failedToUpdateGroup: 'Failed to update group',
    placeholderFullName: 'John Doe',
    placeholderEmail: 'john@example.com',
    placeholderPhone: '+1234567890',
    placeholderCompany: 'Acme Inc',
    placeholderColor: '#3B82F6',
    placeholderPassword: '••••••••',
    placeholderViewName: 'e.g., Adults View, Academy View',
    editGroup: 'Edit Group',
    enterGroupName: 'Enter group name',
    enterDescription: 'Enter description (optional)',

    // Other
    statusNameExample: 'e.g., New, In Progress, Done',

    // Mobile attendance
    pendingAttendance: 'Pending',
    markedAttendance: 'Marked',
    copyToClipboard: 'Copy to clipboard',
    openInWhatsApp: 'Open in WhatsApp',
    leadNotFound: 'Lead not found',

    // Activity Schedule Settings
    activitySchedule: 'Activity Schedule',
    activityScheduleSettingsInfo: 'Configure working days, hours for activities, and default calendar view.',
    defaultCalendarView: 'Default Calendar View',
    defaultCalendarViewHelp: 'Choose the default view when opening the calendar.',
    monthView: 'Month View',
    weekView: 'Week View',
    dayView: 'Day View',
    monthViewDesc: 'See all events in a month',
    weekViewDesc: 'See events by week',
    dayViewDesc: 'See events by day',
    workingDaysAndHours: 'Working Days and Hours',
    workingDaysAndHoursHelp: 'Set which days and hours activities can be scheduled. Disabled days will be highlighted in the calendar.',
    from: 'From',
    to: 'To',
    saveSettings: 'Save Settings',
    settingsSaved: 'Settings saved successfully',
    failedToSaveSettings: 'Failed to save settings',
    settingsReset: 'Settings reset to defaults',
    eventStartDate: 'Start Date & Time',
    eventEndDate: 'End Date & Time',
    daily: 'Daily',
    weekly: 'Weekly',
    monthly: 'Monthly',
    running: 'Running',
    live: 'LIVE',
    date: 'Date',
    time: 'Time',
    selectTime: 'Select time',
    all: 'All',
  },

  he: {
    // Common
    loading: 'טוען...',
    save: 'שמור',
    cancel: 'ביטול',
    delete: 'מחק',
    edit: 'ערוך',
    create: 'צור',
    update: 'עדכן',
    search: 'חיפוש',
    filter: 'סנן',
    appName: 'מערכת ניהול לידים',
    appNameShort: 'לידים',

    // Navigation
    dashboard: 'לוח בקרה',
    leads: 'לידים',
    calendar: 'לוח שנה',
    settings: 'הגדרות',
    apiDocs: 'תיעוד API',
    logout: 'התנתק',

    // Auth
    email: 'אימייל',
    password: 'סיסמה',
    signIn: 'התחבר',
    loginSuccess: 'התחברות הצליחה!',
    loginFailed: 'ההתחברות נכשלה',
    emailRequired: 'אימייל נדרש',
    emailInvalid: 'אימייל לא תקין',
    passwordRequired: 'סיסמה נדרשת',
    passwordMin: 'הסיסמה חייבת להכיל לפחות 6 תווים',
    signInToAccount: 'התחבר לחשבון שלך',
    defaultCredentials: 'פרטי התחברות ברירת מחדל:',
    enterEmail: 'הזן את האימייל שלך',
    enterPassword: 'הזן את הסיסמה שלך',
    unexpectedError: 'אירעה שגיאה בלתי צפויה',
    loggedOutSuccess: 'התנתקת בהצלחה',
    switchLanguage: 'החלף שפה',
    toggleSidebar: 'פתח/סגור תפריט צד',

    // Dashboard
    leadPipeline: 'צינור לידים',
    dragToUpdate: 'גרור ושחרר לידים כדי לעדכן את המצב שלהם',
    addLead: 'הוסף ליד',

    // Leads
    allLeads: 'כל הלידים',
    unnamedLead: 'ליד ללא שם',
    company: 'חברה',
    phone: 'טלפון',
    noLeads: 'אין לידים',
    viewDetails: 'צפה בפרטים',
    deleteLead: 'מחק ליד',
    noDate: 'אין תאריך',

    // Statuses
    leadStatuses: 'סטטוסים של לידים',
    manageStatuses: 'נהל את עמודות הסטטוס המוצגות בלוח הקאנבאן שלך',
    addStatus: 'הוסף סטטוס',
    editStatus: 'ערוך סטטוס',
    createStatus: 'צור סטטוס',
    updateStatus: 'עדכן סטטוס',
    statusName: 'שם הסטטוס',
    color: 'צבע',
    displayOrder: 'סדר תצוגה',
    active: 'פעיל',
    inactive: 'לא פעיל',
    actions: 'פעולות',
    order: 'סדר',
    statusCreated: 'סטטוס נוצר בהצלחה',
    statusUpdated: 'סטטוס עודכן בהצלחה',
    statusDeleted: 'סטטוס נמחק בהצלחה',
    statusDeleteFailed: 'מחיקת הסטטוס נכשלה. ייתכן שהוא בשימוש על ידי לידים.',
    deleteStatusConfirm: 'האם אתה בטוח שברצונך למחוק סטטוס זה? לא ניתן לבטל פעולה זו.',
    failedToLoadStatuses: 'טעינת הסטטוסים נכשלה',
    failedToSaveStatus: 'שמירת הסטטוס נכשלה',

    // Field Labels
    fullNameLabel: 'שם מלא',
    emailLabel: 'אימייל',
    phoneLabel: 'טלפון',
    companyLabel: 'חברה',
    messageLabel: 'הודעה',
    adName: 'שם מודעה',
    campaignName: 'שם קמפיין',
    adsetName: 'שם סט מודעות',
    formId: 'מזהה טופס',
    adId: 'מזהה מודעה',
    campaignId: 'מזהה קמפיין',
    fbLeadId: 'מזהה ליד פייסבוק',
    createdTime: 'זמן יצירה',
    createdDate: 'תאריך יצירה',
    assignedToLabel: 'הוקצה ל',
    sourceLabel: 'מקור',

    // Settings
    settingsTitle: 'הגדרות',
    statuses: 'סטטוסים',
    customFields: 'שדות מותאמים',
    users: 'משתמשים',
    comingSoon: 'בקרוב...',
    displaySettings: 'הגדרות תצוגה',
    branding: 'מיתוג',
    brandingSettings: 'הגדרות מיתוג',
    brandingDescription: 'התאם אישית את הלוגו והפאביקון של האפליקציה',
    applicationLogo: 'לוגו אפליקציה',
    uploadLogo: 'העלה לוגו',
    logoRequirements: 'מומלץ: PNG או SVG, מקסימום 2MB, פורמט מרובע (למשל, 512x512px)',
    noLogo: 'לא הועלה לוגו',
    applicationTitle: 'כותרת אפליקציה',
    customTitle: 'כותרת מותאמת',
    titleRequirements: 'הזן כותרת מותאמת להצגה לצד הלוגו בסרגל הניווט',
    titlePlaceholder: 'לדוגמה, מערכת ניהול לידים',
    titleUpdated: 'הכותרת עודכנה בהצלחה',
    titleRemoved: 'הכותרת הוסרה בהצלחה',
    favicon: 'פאביקון',
    uploadFavicon: 'העלה פאביקון',
    faviconRequirements: 'מומלץ: ICO או PNG, מקסימום 512KB, 32x32px או 16x16px',
    fileTooLarge: 'גודל הקובץ חייב להיות פחות מ-2MB',
    faviconTooLarge: 'גודל הפאביקון חייב להיות פחות מ-512KB',
    logoUpdated: 'הלוגו עודכן בהצלחה',
    faviconUpdated: 'הפאביקון עודכן בהצלחה',
    logoRemoved: 'הלוגו הוסר בהצלחה',
    faviconRemoved: 'הפאביקון הוסר בהצלחה',
    note: 'הערה',
    brandingNote: 'המיתוג שלך יישמר באחסון הדפדפן ויוחל על כל האפליקציה. ניקוי נתוני הדפדפן יאפס את ההגדרות הללו.',
    remove: 'הסר',
    kanbanCardFields: 'שדות כרטיס קאנבאן',
    selectCardFields: 'בחר אילו שדות להציג בכרטיסי הקאנבאן',
    saveCardSettings: 'שמור הגדרות כרטיס',
    modalViewFields: 'שדות תצוגת מודאל',
    selectModalFields: 'בחר אילו שדות להציג במודאל פרטי הליד',
    saveModalSettings: 'שמור הגדרות מודאל',
    activityTags: 'תגיות פעילות',
    manageTags: 'נהל תגיות שניתן להוסיף לפעילויות',
    saveTags: 'שמור תגיות',
    addNewTag: 'הוסף תגית חדשה...',
    addTag: 'הוסף תגית',
    resetToDefaults: 'אפס להגדרות ברירת מחדל',
    required: 'נדרש',
    cardDisplaySettingsSaved: 'הגדרות תצוגת כרטיס נשמרו',
    modalDisplaySettingsSaved: 'הגדרות תצוגת מודאל נשמרו',
    activityTagsSaved: 'תגיות פעילות נשמרו',
    tagAlreadyExists: 'התגית כבר קיימת',
    resetToDefaultSettings: 'אפס להגדרות ברירת מחדל',

    // Quick Stats
    quickStats: 'סטטיסטיקות מהירות',
    totalLeads: 'סה"כ לידים',
    won: 'נסגר',

    // API Documentation
    apiDocumentation: 'תיעוד API',
    apiDocDescription: 'מדריך מלא לכל נקודות הקצה הזמינות ב-API',
    baseUrl: 'כתובת בסיס',
    authentication: 'אימות',
    authDescription: 'כלול את אסימון JWT בכותרת Authorization כ',
    howToAuthenticate: 'כיצד להתחבר',
    authStep1: 'התחבר באמצעות',
    authStep1b: 'עם האימייל והסיסמה שלך',
    authStep2: 'שמור את האסימון מהתגובה',
    authStep3: 'כלול את האסימון בכל הבקשות הבאות בכותרת Authorization',
    exampleCurl: 'דוגמה עם cURL',
    exampleJavaScript: 'דוגמה עם JavaScript (fetch)',
    requiresAuth: 'נדרש אימות',
    queryParameters: 'פרמטרי שאילתה',
    requestBody: 'גוף הבקשה',
    response: 'תגובה',
    copy: 'העתק',
    exampleUsage: 'דוגמת שימוש',

    // Toasts
    failedToLoad: 'טעינת הנתונים נכשלה',
    leadStatusUpdated: 'סטטוס הליד עודכן',
    failedToUpdate: 'עדכון סטטוס הליד נכשל',

    // Lead Form
    fullName: 'שם מלא',
    fullNameRequired: 'שם מלא נדרש',
    emailRequired: 'אימייל נדרש',
    message: 'הודעה',
    status: 'סטטוס',
    statusRequired: 'סטטוס נדרש',
    selectStatus: 'בחר סטטוס...',
    createLead: 'צור ליד',
    updateLead: 'עדכן ליד',
    leadCreated: 'הליד נוצר בהצלחה',
    leadUpdated: 'הליד עודכן בהצלחה',
    failedToCreateLead: 'יצירת הליד נכשלה',
    failedToUpdateLead: 'עדכון הליד נכשל',
    additionalNotes: 'הערות או הודעה נוספת...',
    actionDate: 'תאריך פעולה',
    actionDateHelp: 'תאריך אימון ניסיון, תאריך מעקב, או תאריך יצירת קשר',
    assignToEvent: 'הקצה לאירוע',
    noEvent: 'ללא אירוע',
    assignToEventHelp: 'הקצאה לאירוע תגדיר אוטומטית את תאריך הפעולה',
    actionDateFromEvent: 'תאריך הפעולה מוגדר מהאירוע',
    preferredDays: 'ימים מועדפים',
    preferredDaysHelp: 'בחר את הימים המתאימים ביותר עבור הליד',
    sunday: 'ראשון',
    monday: 'שני',
    tuesday: 'שלישי',
    wednesday: 'רביעי',
    thursday: 'חמישי',
    friday: 'שישי',
    saturday: 'שבת',
    messageTypes: 'סוגי הודעות',
    messageTypesHelp: 'בחר כיצד הליד מעדיף להיות מנותק',
    messageType: 'סוג הודעה',
    manageMessageTypes: 'הגדר את סוגי ההודעות שלידים יכולים לקבל',
    addNewMessageType: 'הוסף סוג הודעה חדש...',
    add: 'הוסף',
    noMessageTypes: 'לא הוגדרו סוגי הודעות עדיין',
    messageTypeRequired: 'שם סוג ההודעה נדרש',
    messageTypeAdded: 'סוג הודעה נוסף בהצלחה',
    messageTypeUpdated: 'סוג הודעה עודכן בהצלחה',
    messageTypeDeleted: 'סוג הודעה נמחק בהצלחה',
    deleteMessageTypeConfirm: 'האם אתה בטוח שברצונך למחוק סוג הודעה זה?',

    // Events
    events: 'אירועים',
    event: 'אירוע',
    manageEvents: 'נהל אימוני ניסיון, סדנאות ואירועים אחרים',
    viewEventsCalendar: 'צפה בכל האירועים בפורמט לוח שנה',
    today: 'היום',
    month: 'חודש',
    week: 'שבוע',
    day: 'יום',
    recurrence: 'הישנות',
    recurrenceType: 'חזרה',
    noRecurrence: 'לא חוזר',
    recurrenceEndDate: 'מסתיים ב',
    recurrenceEndDateHelp: 'תאריך אחרון לאירועים חוזרים',
    addEvent: 'הוסף אירוע',
    editEvent: 'ערוך אירוע',
    eventName: 'שם האירוע',
    eventDate: 'תאריך האירוע',
    activityCategory: 'קטגוריית פעילות',
    selectActivity: 'בחר פעילות...',
    location: 'מיקום',
    capacity: 'קיבולת',
    visibility: 'נראות',
    public: 'ציבורי',
    private: 'פרטי',
    assigned: 'מוקצים',
    noEvents: 'לא נמצאו אירועים',
    privateEvent: 'אירוע פרטי',
    past: 'עבר',
    full: 'מלא',
    unlimited: 'בלתי מוגבל',
    upcomingOnly: 'עתידיים בלבד',
    showAll: 'הצג הכל',
    eventCreated: 'אירוע נוצר בהצלחה',
    eventUpdated: 'אירוע עודכן בהצלחה',
    eventDeleted: 'אירוע נמחק בהצלחה',
    deleteEventConfirm: 'האם אתה בטוח שברצונך למחוק אירוע זה?',
    cannotDeleteEventWithLeads: 'לא ניתן למחוק אירוע עם לידים מוקצים',
    eventDeleteFailed: 'מחיקת האירוע נכשלה',
    failedToLoadEvents: 'טעינת האירועים נכשלה',
    failedToSaveEvent: 'שמירת האירוע נכשלה',
    capacityHelp: '0 = קיבולת בלתי מוגבלת',
    description: 'תיאור',
    assignedLeads: 'לידים מוקצים',
    noLeadsAssigned: 'אין לידים מוקצים לאירוע זה',
    addLeadToEvent: 'הוסף ליד לאירוע',
    addLeadToEventInfo: 'בחר ליד להוספה לאירוע זה.',
    searchLead: 'חפש ליד',
    selectLead: 'בחר ליד',
    searchByNameOrPhone: 'חפש לפי שם או טלפון...',
    pleaseSelectLead: 'אנא בחר ליד',
    leadAddedToEvent: 'הליד נוסף לאירוע בהצלחה',
    failedToAddLead: 'הוספת הליד לאירוע נכשלה',
    add: 'הוסף',
    viewAssignedLeads: 'צפה בלידים מוקצים',
    failedToLoadLeads: 'טעינת הלידים נכשלה',
    name: 'שם',
    group: 'קבוצה',
    attendance: 'נוכחות',
    attended: 'הגיע',
    absent: 'לא הגיע',
    pending: 'ממתין',
    resetAttendance: 'אפס נוכחות',
    attendanceUpdated: 'נוכחות עודכנה בהצלחה',
    failedToUpdateAttendance: 'עדכון הנוכחות נכשל',

    // Lead Detail Modal
    addNewLead: 'הוסף ליד חדש',
    leadDetails: 'פרטי ליד',
    editLead: 'ערוך ליד',
    eventHistory: 'היסטוריית אירועים',
    noEventHistory: 'אין רישומי נוכחות באירועים',
    upcoming: 'עתידי',
    markedBy: 'סומן על ידי',
    close: 'סגור',
    created: 'נוצר',
    assignedTo: 'הוקצה ל',
    source: 'מקור',
    activityTimeline: 'ציר זמן פעילות',
    noActivity: 'אין פעילות עדיין',

    // Activity Types
    statusChange: 'שינה סטטוס מ',
    to: 'ל',
    leadCreatedActivity: 'יצר את הליד',
    leadUpdatedActivity: 'עדכן מידע על הליד',
    noteAdded: 'הוסיף הערה',
    assignmentChanged: 'הקצה ליד ל',
    system: 'מערכת',
    justNow: 'ממש עכשיו',
    minuteAgo: 'לפני דקה',
    minutesAgo: 'דקות',
    hourAgo: 'לפני שעה',
    hoursAgo: 'שעות',
    dayAgo: 'לפני יום',
    daysAgo: 'ימים',

    // Errors
    failedToLoadLeadDetails: 'טעינת פרטי הליד נכשלה',
    failedToLoadStatuses: 'טעינת הסטטוסים נכשלה',
    failedToLoadActivityTimeline: 'טעינת ציר הזמן נכשלה',

    // Delete
    confirmDelete: 'אישור מחיקה',
    confirmDeleteMessage: 'האם אתה בטוח שברצונך למחוק את',
    deleteWarning: 'לא ניתן לבטל פעולה זו.',
    leadDeleted: 'הליד נמחק בהצלחה',
    failedToDelete: 'מחיקת הליד נכשלה',

    // Duplicates
    checkingDuplicates: 'בודק כפילויות...',
    duplicateLeadsFound: 'נמצאו לידים כפולים אפשריים',
    duplicate: 'כפול',
    duplicateWarning: 'לליד הזה יש מספרי טלפון כפולים עם לידים אחרים',

    // Bulk Actions
    selectAll: 'בחר הכל',
    deselectAll: 'בטל בחירת הכל',
    selectAllInStatus: 'בחר הכל בסטטוס זה',
    deselectAllInStatus: 'בטל בחירת הכל בסטטוס זה',
    bulkActions: 'פעולות מרובות',
    selectedLeads: 'לידים נבחרו',
    bulkDelete: 'מחק נבחרים',
    bulkDeleteConfirm: 'האם אתה בטוח שברצונך למחוק את הלידים הנבחרים?',
    bulkDeleteSuccess: 'לידים נמחקו בהצלחה',
    bulkDeleteFailed: 'מחיקת חלק מהלידים נכשלה',
    bulkEdit: 'עריכה מרובה',
    bulkEditInfo: 'השינויים יוחלו על',
    bulkEditNote: 'רק השדות שנבחרו יעודכנו. שדות ריקים יישארו ללא שינוי.',
    bulkUpdateSuccess: 'עודכנו בהצלחה',
    bulkUpdateFailed: 'עדכון הלידים נכשל',
    bulkUpdatePartialFail: 'נכשל לעדכן',
    noChange: '-- ללא שינוי --',
    noChangesSelected: 'אנא בחר לפחות שדה אחד לעדכון',
    updateSelected: 'עדכן נבחרים',
    noLeadsSelected: 'לא נבחרו לידים',
    selectionMode: 'מצב בחירה',
    exitSelectionMode: 'צא ממצב בחירה',

    // Users
    userManagement: 'ניהול משתמשים',
    manageSystemUsers: 'נהל משתמשי מערכת והרשאותיהם',
    addUser: 'הוסף משתמש',
    editUser: 'ערוך משתמש',
    createUser: 'צור משתמש',
    updateUser: 'עדכן משתמש',
    role: 'תפקיד',
    admin: 'מנהל',
    user: 'משתמש',
    passwordLabel: 'סיסמה',
    passwordLabelOptional: 'סיסמה (השאר ריק כדי לשמור את הנוכחית)',
    userUpdatedSuccessfully: 'משתמש עודכן בהצלחה',
    userCreatedSuccessfully: 'משתמש נוצר בהצלחה',
    userDeletedSuccessfully: 'משתמש נמחק בהצלחה',
    confirmDeleteUser: 'האם אתה בטוח שברצונך למחוק משתמש זה?',
    failedToLoadUsers: 'טעינת המשתמשים נכשלה',

    // Views
    views: 'תצוגות',
    filteredViews: 'תצוגות מסוננות',
    filteredViewsDescription: 'צור תצוגות מסוננות לפי סוג פעילות (שם קמפיין)',
    addView: 'הוסף תצוגה',
    editView: 'ערוך תצוגה',
    createView: 'צור תצוגה',
    updateView: 'עדכן תצוגה',
    viewName: 'שם התצוגה',
    activityFilter: 'סינון פעילות',
    filterByActivity: 'סנן לפי פעילות',
    filterByActivityHelp: 'זה יסנן לידים שבהם שם הקמפיין מכיל את הפעילות שנבחרה',
    allActivities: 'כל הפעילויות',
    default: 'ברירת מחדל',
    setAsDefault: 'הגדר כברירת מחדל',
    noViewsYet: 'אין תצוגות עדיין',
    createFirstViewDescription: 'צור את התצוגה המסוננת הראשונה שלך כדי לארגן לידים לפי פעילות',
    createFirstView: 'צור תצוגה ראשונה',
    viewUpdatedSuccessfully: 'תצוגה עודכנה בהצלחה',
    viewCreatedSuccessfully: 'תצוגה נוצרה בהצלחה',
    viewDeletedSuccessfully: 'תצוגה נמחקה בהצלחה',
    confirmDeleteView: 'האם אתה בטוח שברצונך למחוק תצוגה זו?',
    defaultViewUpdated: 'תצוגת ברירת המחדל עודכנה',
    failedToSetDefaultView: 'הגדרת תצוגת ברירת המחדל נכשלה',
    failedToLoadViews: 'טעינת התצוגות נכשלה',
    failedToLoadActivities: 'טעינת הפעילויות נכשלה',
    all: 'הכל',

    // Activities & Groups
    addActivity: 'הוסף פעילות',
    addGroup: 'הוסף קבוצה',
    activity: 'פעילות',
    activityName: 'שם פעילות',
    activities: 'פעילויות',
    assign: 'הקצה',
    assignGroup: 'הקצה קבוצה',
    assignGroupInfo: 'בחר קבוצה להקצות את כל החברים שלה לאירוע זה',
    conversionRate: 'שיעור המרה',
    currentCapacity: 'קיבולת נוכחית',
    displayOrderHelp: 'מספר נמוך יותר יוצג ראשון',
    enterActivityName: 'הזן שם פעילות',
    enterDescription: 'הזן תיאור',
    enterGroupName: 'הזן שם קבוצה',
    groupHelp: 'קבוצות מסייעות לארגן ולנהל לידים',
    groupName: 'שם קבוצה',
    groups: 'קבוצות',
    manageActivities: 'נהל פעילויות ותגיות שניתן להוסיף ללידים',
    manageGroups: 'נהל קבוצות לארגון לידים',
    newToday: 'חדש היום',
    noGroup: 'אין קבוצה',
    selectActivity: 'בחר פעילות',
    selectGroup: 'בחר קבוצה',
    upcomingEvents: 'אירועים קרובים',
    pastEvents: 'אירועים קודמים',
    'Upcoming Events': 'אירועים קרובים',
    waitingList: 'רשימת המתנה',
    confirmedAttendees: 'משתתפים מאושרים',
    confirm: 'אשר',
    eventAtCapacity: 'האירוע הגיע למלוא התפוסה',
    leadConfirmedFromWaitingList: 'הליד אושר מרשימת ההמתנה בהצלחה',
    failedToConfirmLead: 'נכשל לאשר ליד מרשימת ההמתנה',
    pendingAttendance: 'טרם סומן',
    markedAttendance: 'סומנו',
    copyToClipboard: 'העתק ללוח',
    openInWhatsApp: 'פתח בווטסאפ',
    leadNotFound: 'ליד לא נמצא',

    // System & Application
    Admin: 'מנהל',
    'Lead Management System': 'מערכת ניהול לידים',
    Views: 'תצוגות',
    'John Doe': 'יוחנן ישראלי',
    MEMBERS: 'חברים',
    healthDeclaration: 'הצהרת בריאות',
    healthDeclarationReceived: 'הצהרת בריאות התקבלה - לחץ לביטול',
    healthDeclarationNotReceived: 'אין הצהרת בריאות - לחץ לסימון',
    healthDeclarationUpdated: 'הצהרת בריאות עודכנה בהצלחה',
    missingHealthDeclaration: 'חסרה הצהרת בריאות',
    failedToUpdateHealthDeclaration: 'שגיאה בעדכון הצהרת בריאות',
    assignedOfCapacity: 'מוקצים / קיבולת',
    didntArrive: 'לא הגיע',
    unassign: 'בטל הקצאה',
    confirmUnassignLead: 'האם אתה בטוח שברצונך לבטל הקצאה של ליד זה מהאירוע?',
    leadUnassigned: 'הקצאת הליד מהאירוע בוטלה בהצלחה',
    failedToUnassignLead: 'ביטול הקצאת הליד נכשל',
    cannotUnassignAttendedLead: 'לא ניתן לבטל הקצאת ליד שנכח באירוע. סמן כנעדר תחילה.',
    pleaseSelectGroup: 'אנא בחר קבוצה',
    groupAssignedToEvent: 'קבוצה הוקצתה לאירוע בהצלחה',
    eventCapacityExceeded: 'קיבולת האירוע תעלה על המותר',
    groupNotFound: 'קבוצה לא נמצאה',
    eventNotFound: 'אירוע לא נמצא',
    failedToAssignGroup: 'הקצאת הקבוצה לאירוע נכשלה',
    members: 'חברים',
    totalMembers: 'סה"כ חברים',
    addMember: 'הוסף חבר',
    addMembers: 'הוסף חברים',
    noMembers: 'אין חברים בקבוצה זו',
    remove: 'הסר',
    confirmRemoveMember: 'האם אתה בטוח שברצונך להסיר חבר זה מהקבוצה?',
    memberRemoved: 'חבר הוסר מהקבוצה בהצלחה',
    failedToRemoveMember: 'הסרת החבר מהקבוצה נכשלה',
    searchLeads: 'חפש לידים',
    searchByNamePhoneEmail: 'חפש לפי שם, טלפון או אימייל...',
    noLeadsFound: 'לא נמצאו לידים התואמים את החיפוש',
    noAvailableLeads: 'אין לידים זמינים ללא קבוצה',
    failedToAddMember: 'הוספת חבר לקבוצה נכשלה',
    memberAdded: 'חבר נוסף לקבוצה בהצלחה',
    groupMembers: 'חברי קבוצה',
    viewMembers: 'צפה בחברים',
    failedToLoadMembers: 'טעינת חברי הקבוצה נכשלה',
    failedToLoadGroups: 'טעינת הקבוצות נכשלה',
    copyParticipantsList: 'העתק רשימת משתתפים',
    copiedToClipboard: 'הועתק ללוח',
    failedToCopy: 'העתקה נכשלה',
    noLeadsToCopy: 'אין משתתפים להעתקה',
    groupUpdated: 'קבוצה עודכנה בהצלחה',
    groupCreated: 'קבוצה נוצרה בהצלחה',
    groupDeleted: 'קבוצה נמחקה בהצלחה',
    deleteGroupConfirm: 'האם אתה בטוח שברצונך למחוק קבוצה זו?',
    cannotDeleteGroupWithMembers: 'לא ניתן למחוק קבוצה עם חברים. הסר את כל החברים תחילה.',
    groupDeleteFailed: 'מחיקת הקבוצה נכשלה',
    failedToSaveGroup: 'שמירת הקבוצה נכשלה',
    groupAlreadyExists: 'קבוצה עם שם זה כבר קיימת',
    failedToUpdateGroup: 'עדכון הקבוצה נכשל',
    placeholderFullName: 'ישראל ישראלי',
    placeholderEmail: 'israel@example.com',
    placeholderPhone: '+972501234567',
    placeholderCompany: 'חברת דוגמה בע״מ',
    placeholderColor: '#3B82F6',
    placeholderPassword: '••••••••',
    placeholderViewName: 'לדוגמה: תצוגת מבוגרים, תצוגת אקדמיה',
    editGroup: 'ערוך קבוצה',
    enterGroupName: 'הזן שם קבוצה',
    enterDescription: 'הזן תיאור (אופציונלי)',

    // Other
    statusNameExample: 'לדוגמה: חדש, בתהליך, הושלם',

    // Activity Schedule Settings
    activitySchedule: 'לוח זמנים לפעילויות',
    activityScheduleSettingsInfo: 'הגדר ימי עבודה, שעות לפעילויות ותצוגת ברירת מחדל ללוח השנה.',
    defaultCalendarView: 'תצוגת ברירת מחדל ללוח שנה',
    defaultCalendarViewHelp: 'בחר את תצוגת ברירת המחדל בעת פתיחת לוח השנה.',
    monthView: 'תצוגת חודש',
    weekView: 'תצוגת שבוע',
    dayView: 'תצוגת יום',
    monthViewDesc: 'צפה בכל האירועים בחודש',
    weekViewDesc: 'צפה באירועים לפי שבוע',
    dayViewDesc: 'צפה באירועים לפי יום',
    workingDaysAndHours: 'ימי ושעות עבודה',
    workingDaysAndHoursHelp: 'הגדר באילו ימים ושעות ניתן לתזמן פעילויות. ימים לא פעילים יסומנו בלוח השנה.',
    from: 'מ',
    to: 'עד',
    saveSettings: 'שמור הגדרות',
    settingsSaved: 'ההגדרות נשמרו בהצלחה',
    failedToSaveSettings: 'שמירת ההגדרות נכשלה',
    settingsReset: 'ההגדרות אופסו לברירת מחדל',
    eventStartDate: 'תאריך ושעת התחלה',
    eventEndDate: 'תאריך ושעת סיום',
    daily: 'יומי',
    weekly: 'שבועי',
    monthly: 'חודשי',
    running: 'בתהליך',
    live: 'בשידור חי',
    date: 'תאריך',
    time: 'שעה',
    selectTime: 'בחר שעה',
    all: 'הכל',
  },
};
